
Vue.use(window.VueDragscroll)

Vue.component('penalty-list', {
  props: {
    seriesId: {
      type: String,
      required: true,
    },
    teams: {
      type: Array,
      required: true,
    },
  },
  template: `
<section>
  <div class="mb-6">
    <div class="field is-grouped is-grouped-multiline">
      <div class="control" v-for="card in cardTypes.yellow" :key="card[0]">
        <div class="tags has-addons"><span class="tag yellow-card">{{ card[0] }}</span><span class="tag">{{ card[1] }}</span></div>
      </div>
      <div class="control" v-for="card in cardTypes.red" :key="card[0]">
        <div class="tags has-addons"><span class="tag red-card">{{ card[0] }}</span><span class="tag">{{ card[1] }}</span></div>
      </div>
    </div>
  </div>
  <template v-if="isLoading">
    <div class="loader">Loading...</div>
  </template>
  <template v-else="v-else">
    <div class="is-flex is-align-items-center has-background-light p-2"><span class="pr-4">チーム選択</span>
      <div class="select">
        <select v-model="selectedTeamId">
          <option v-for="option in teamFilterList" :value="option.value">{{ option.text }}</option>
        </select>
      </div>
    </div>
    <section class="mt-5 px-3" v-for="(team, i) in filteredTeams" :key="team._id">
      <h2 class="is-5">{{ team.shortName }}</h2>
      <div class="table-container cursor-grab" v-dragscroll="{}">
        <table class="table is-striped penalty-table">
          <thead>
            <tr>
              <th>背番号</th>
              <th>氏名</th>
              <th class="has-text-centered">警告数</th>
              <th class="has-text-centered">退場数</th>
              <th v-for="section in sections" :key="section">{{ section }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="member in playerAndStaff(team)" :key="member.playerId">
              <td class="is-size-7">{{ member.number || member.position }}</td>
              <td>{{ member.name }}</td>
              <td class="has-text-centered">{{ yellowCount(team._id, member.playerId) }}</td>
              <td class="has-text-centered">{{ redCount(team._id, member.playerId) }}</td>
              <td v-for="section in sections" :key="section"><span class="tag mr-1" v-for="(card, j) in cards(team._id, section, member.playerId)" :key="j" :class="cardColor(card)">{{ card }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>
  </template>
</section>`,
  data() {
    return {
      games: [],
      sections: [],
      cardData: {},
      cardTypes: CARD_TYPES,
      cardColors: {},
      isLoading: true,
      selectedTeamId: '',
    }
  },
  async created() {
    // カード色のclass変換用テーブルを定義する
    const cardColors = {}
    _.forEach(CARD_TYPES, (types, color) => {
      types.forEach(([type]) => {
        cardColors[type] = `${color}-card`
      })
    })
    this.cardColors = cardColors

  // 試合データを取得する
    const {
      data: { entries }
    } = await axios.post('/api/collections/get/games', {
      filter: {
        seriesId: this.seriesId,
        published: true,
      },
      populate: 1,
    })
    this.games = entries

    // 警告データを集計する
    let max = 1
    const cards = {}

    this.games.forEach((game) => {
      // 最大セクションの確認
      const sec = parseInt(game.section, 10)
      if (max < sec) {
        max = sec
      }

      (game.gameRecords || []).forEach((item) => {
        const teamId = item.team._id
        const section = game.section
        cards[teamId] = cards[teamId] || {}
        cards[teamId][section] = cards[teamId][section] || {}
        item.records.forEach((rec) => {
          if (rec.value.type !== 'card') {
            return
          }
          // カード情報をcardsにセットする
          const playerId = rec.value.playerId
          cards[teamId][section][playerId] = cards[teamId][section][playerId] || []
          cards[teamId][section][playerId].push(rec.value.card)
        })
      })
    })
    this.cardData = cards
    this.sections = [...Array(max)].map((_i, i) => {
      return i + 1
    })

    this.isLoading = false
  },
  computed: {
    teamFilterList() {
      return [ { text: 'すべて', value: '' }, ...this.teams.map((team) => ({ text: team.shortName, value: team._id })) ]
    },
    filteredTeams() {
      if (this.selectedTeamId) {
        return this.teams.filter((team) => team._id === this.selectedTeamId)
      }
      return this.teams
    },
  },
  methods: {
    playerAndStaff(team) {
      return _.filter(team.members, (m) => {
        return _.includes(['player', 'staff'], m.role) && this.sections.some((section) => this.cards(team._id, section, m.playerId).length > 0)
      })
    },
    cards(teamId, section, playerId) {
      const cards = _.get(this.cardData, [teamId, section, playerId], [])
      const yellows = cards.reduce((num, card) => {
        if (card.startsWith('C')) {
          num += 1
        }
        return num
      }, 0)
      if (yellows > 1) {
        return [...cards, 'CS']
      }
      return cards
    },
    cardColor(card) {
      return this.cardColors[card] || ''
    },
    // イエローカードの枚数
    yellowCount(teamId, playerId) {
      const sections = _.get(this.cardData, [teamId], {})
      let cnt = 0
      _.forEach(sections, (item) => {
        const yellows = _.filter(item[playerId], (card) => {
          return card.startsWith('C')
        })
        if (yellows.length === 1) {
          cnt += 1
        }
      })
      return cnt
    },
    // レッドカードの枚数
    redCount(teamId, playerId) {
      const sections = _.get(this.cardData, [teamId], {})
      let cnt = 0
      _.forEach(sections, (item) => {
        const yellows = _.filter(item[playerId], (card) => {
          return card.startsWith('C')
        })
        if (yellows.length > 1) {
          cnt += 1
        }
        const reds = _.filter(item[playerId], (card) => {
          return card.startsWith('S')
        })
        cnt += reds.length
      })
      return cnt
    },
  }
})